import React from 'react';
//import Popup from './Popup';
import Widgets from './Widgets';
import { useLocation } from 'react-router-dom';
//import { useParams } from 'react-router-dom';
import Invoice from './Invoice';

function WidgetsOnly({ activeTheme, clientName, font, language, setActiveTheme, selectedLayout, carbon, rating, addcss }) {
    const { search } = useLocation();
    const params = new URLSearchParams(search);

  activeTheme = activeTheme || params.get('color') || "yellow";
  language = language || params.get('language') || "english";
  clientName = clientName || params.get('clientName') || "apparel";
  selectedLayout = selectedLayout || params.get('layout') || "layout-featured";
  font = font || params.get('font') || "fira";
  carbon = carbon || params.get('carbon') || "0";
  rating = rating || params.get('rating') || "0";
  addcss = addcss || params.get('addcss') || "0";

  return (
    <>
      <div className="d-none">
      <Invoice activeTheme={activeTheme} clientName={clientName} language={language} font={font} setActiveTheme={setActiveTheme}  selectedLayout={selectedLayout} carbon={carbon} rating={rating}/>
      </div>
      <Widgets 
        activeTheme={activeTheme} 
        clientName={clientName} 
        font={font} 
        language={language} 
        setActiveTheme={setActiveTheme} 
        selectedLayout={selectedLayout} 
        carbon={carbon} 
        rating={rating} 
        addcss={addcss} 
      />
    </>
  );
}

export default WidgetsOnly;